module.exports = __webpack_public_path__ + "static/img/h2_x2.5c8140f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h2_x2.png
// module id = Ggu9
// module chunks = 1